export default __webpack_public_path__ + "static/media/empty-state-crew-notes.60145dc1.svg";